import { fetchApi } from '@/config/axiosSetting.ts';
import { FileInformationQuery } from '@/modules/FileDetail/queries/fileInformation/fileInformationQuery.type.ts';

export const fileInformationQueryFunction = (
  id: string,
): Promise<FileInformationQuery> =>
  fetchApi.get(`/file_information/${id}/file_information/`);
